import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumBeerflexOrderConfirmationStatus implements BaseEnumType {
  private static allValues: EnumBeerflexOrderConfirmationStatus[] = []; // make sure this is top-most
  
  public static none = new EnumBeerflexOrderConfirmationStatus(0, "None", "enum_beerflex_order_confirmation_status_none");
  public static unconfirmed = new EnumBeerflexOrderConfirmationStatus(1, "Unconfirmed", "enum_beerflex_order_confirmation_status_unconfirmed");
  public static confirmedDelivered = new EnumBeerflexOrderConfirmationStatus(2, "ConfirmedDelivered", "enum_beerflex_order_confirmation_status_confirmed_delivered");
  public static confirmedFailed = new EnumBeerflexOrderConfirmationStatus(3, "ConfirmedFailed", "enum_beerflex_order_confirmation_status_confirmed_failed");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumBeerflexOrderConfirmationStatus.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isNone() { return this === EnumBeerflexOrderConfirmationStatus.none; }
  public isUnconfirmed() { return this === EnumBeerflexOrderConfirmationStatus.unconfirmed; }
  public isConfirmedDelivered() { return this === EnumBeerflexOrderConfirmationStatus.confirmedDelivered; }
  public isConfirmedFailed() { return this === EnumBeerflexOrderConfirmationStatus.confirmedFailed; }

  public static getValues(): readonly EnumBeerflexOrderConfirmationStatus[] {
    return EnumBeerflexOrderConfirmationStatus.allValues;
  }

  public static getValuesExcept0(): readonly EnumBeerflexOrderConfirmationStatus[] {
    return EnumBeerflexOrderConfirmationStatus.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumBeerflexOrderConfirmationStatus {
    const found = EnumBeerflexOrderConfirmationStatus.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumBeerflexOrderConfirmationStatus - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumBeerflexOrderConfirmationStatus): EnumBeerflexOrderConfirmationStatus {
    const found = name ? EnumBeerflexOrderConfirmationStatus.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumBeerflexOrderConfirmationStatus - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumBeerflexOrderConfirmationStatus>): boolean {
    return this.key === other?.key;
  }
}